import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


import { Link } from 'react-router-dom';
import moment from 'moment';


export default class CreatedPollList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            createdPoll: [],
            disableQuestions: false,
            disableDelete: false,
            loader: true,
            deletingPollId: null,
            deletePollId: null,

        };
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getCreatedPoll = this.getCreatedPoll.bind(this);
        this.deletePoll = this.deletePoll.bind(this);
    }

    componentDidMount() {
        this.getCreatedPoll();
    }

    getCreatedPoll() {
        this.setState({
            loader: true
        });
        let status = this.props.statuses.find((e) => e.key === 'in progress');
        localStorage.setItem('pollStatus', status.value);
        axios.get(`/questionnaire/all/${status.value}/`)
            .then(res => {
                const createdPoll = res.data;
                this.setState({ createdPoll, loader: false });
            })
            .catch(err => {
                this.setState({ loader: false });
                toast('Došlo je do greške. Nije moguće prikazati kreirane ankete.');
                console.log('Failed to fetch created poll.');
            });
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.createdPoll;
    }

    deletePoll(id) {
        this.setState({
            disableQuestions: true, disableDelete: true, deletePollId: null, deletingPollId: id
        });
        let obj = {
            id,
            questionnaireStatus: { id: localStorage.getItem('pollStatus') }
        };
        axios.delete('questionnaire/delete/', { data: obj })
            .then(res => {
                toast('Uspješno ste obrisali anketu.');
                this.setState({
                    loader: false, disableQuestions: false, disableDelete: false, deletingPollId: null
                });
            }).then(() => {
                this.getCreatedPoll();
            })
            .catch(err => {
                this.setState({
                    loader: false, disableQuestions: false, disableDelete: false, deletingPollId: null
                });
                toast('Došlo je do greške. Brisanje ankete nije uspjelo.');
            });
    }

    render() {
        return (

            <div>


                {this.state.loader ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader size="medium" active /></div> : this.getDataToRender().length ? <Table celled selectable compact>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell >
                                Naziv
                            </Table.HeaderCell>
                            <Table.HeaderCell >
                                Tip
                            </Table.HeaderCell>
                            <Table.HeaderCell >
                                Datum objave
                            </Table.HeaderCell>
                            <Table.HeaderCell >
                                Datum isteka
                            </Table.HeaderCell>

                            <Table.HeaderCell colSpan="1" ></Table.HeaderCell>


                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.getDataToRender().map((el) =>
                            (<Table.Row key={el.id}>
                                <Table.Cell verticalAlign="middle">
                                    {el.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.questionnaireType.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" >
                                    {moment(el.activationDate).format('D. M. YYYY.')}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" >
                                    {moment(el.endDate).format('D. M. YYYY.')}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" textAlign="center" colSpan="1">
                                    {this.state.deletePollId === el.id ? <div>
                                        <Popup
                                            content="Potvrdi"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="check"
                                                    size="small"
                                                    color="blue"
                                                    loading={this.state.deletingPollId === el.id}
                                                    disabled={this.state.deletingPollId === el.id}
                                                    onClick={() => { this.deletePoll(el.id); }}
                                                ></Button>}
                                        >
                                        </Popup>
                                        <Popup
                                            content="Odustani"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="delete"
                                                    size="small"
                                                    color="red"
                                                    disabled={this.state.deletingPollId === el.id}
                                                    onClick={() => { this.setState({ deletePollId: null }); }}
                                                >
                                                </Button>}
                                        >
                                        </Popup>
                                    </div> :
                                        <div>
                                            <Link to={{ pathname: '/ankete/detalji' }}>
                                                <Popup
                                                    content="Detalji ankete"
                                                    position="top center"
                                                    trigger={
                                                        <span><Button
                                                            basic="true"
                                                            circular
                                                            icon="align justify"
                                                            size="small"
                                                            color="blue"
                                                            disabled={this.state.disableDelete}
                                                            onClick={() => { // seta se flag da se moze editovati
                                                                let poll = {
                                                                    pollId: el.id,
                                                                    pollName: el.name,
                                                                    pollType: el.questionnaireType.id,
                                                                    pollStatus: el.questionnaireStatus.id
                                                                };
                                                                localStorage.setItem('poll', JSON.stringify(poll));
                                                                localStorage.setItem('fullPoll', JSON.stringify(el));
                                                                localStorage.setItem('edit', 'enable');
                                                                localStorage.setItem('delete', 'enable');
                                                            }}
                                                        >
                                                </Button></span>}
                                                />
                                            </Link>
                                            <Popup
                                                content="Obriši anketu"
                                                position="top center"
                                                trigger={
                                                    <span><Button
                                                        basic
                                                        circular
                                                        icon="trash alternate"
                                                        size="small"
                                                        color="red"
                                                        loading={this.state.deletingPollId === el.id}
                                                        disabled={this.state.disableDelete}
                                                        onClick={() => { this.setState({ deletePollId: el.id }); }}
                                                    >
                                                </Button></span>}
                                            />
                                        </div>}

                                </Table.Cell>
                            </Table.Row>))}
                    </Table.Body>
                </Table> : 'Trenutno nema kreiranih anketa.'}
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/PollTabs/CreatedPollList.js